/**
 * Helpers para o widget Tawk.to (atendimento humano), carregado globalmente em
 * public/index.html. Como o script remoto carrega de forma assíncrona, os métodos
 * (hideWidget/showWidget/maximize) podem ainda não existir quando o Vue monta —
 * por isso enfileiramos via `Tawk_API.onLoad` quando necessário.
 *
 * Regra de convivência com o guIAre: onde o chat guIAre aparece, escondemos o
 * balão do Tawk; o acesso ao atendente humano fica dentro do próprio guIAre
 * (botão "falar com atendente" → openTawk()).
 */

function withTawk(fn) {
	const api = window.Tawk_API;
	if (!api) return;

	if (typeof api.hideWidget === 'function') {
		fn(api);
		return;
	}

	// Ainda não carregou: encadeia no onLoad preservando handler anterior.
	const previous = api.onLoad;
	api.onLoad = function () {
		if (typeof previous === 'function') previous();
		fn(window.Tawk_API);
	};
}

export function hideTawk() {
	withTawk((api) => api.hideWidget());
}

export function showTawk() {
	withTawk((api) => api.showWidget());
}

/**
 * Abre o atendimento humano sob demanda (a partir do guIAre): mostra o balão e
 * maximiza o chat. Ao minimizar, volta a esconder pra não competir com o guIAre.
 */
export function openTawk() {
	withTawk((api) => {
		api.onChatMinimized = function () {
			api.hideWidget();
		};
		api.showWidget();
		api.maximize();
	});
}

export default { hideTawk, showTawk, openTawk };
